/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { IMG } from "components";
import { FC } from "react";

interface Props {
  src: string;
  extension?: string;
  [key: string]: any
}
const DocumentViewer: FC<Props> = ({
  src,
  extension,
  ...args
}) => {
  if (extension === "pdf") {
    return <embed src={src} width="100%" height="100%" {...args} />;
  }
  return <IMG key={src} src={src} {...args} />;
};

export default DocumentViewer;